import { UIMatch, useMatches } from 'react-router-dom';
import { StepHandle } from 'types/routing/proposal-step-handle';

export const useGetReportCurrentStep = () => {
  const matches = useMatches() as UIMatch<unknown, StepHandle>[];
  const steps = matches
    .filter((match) => Boolean(match.handle?.stepNumber))
    .map((step) => step.handle.stepNumber);

  if (steps.length === 0) {
    return undefined;
  }

  return steps[0];
};
